import React from 'react';
import styled from 'styled-components/macro';

interface DiscountBadgeProps {
    children: React.ReactNode;
}

const DiscountBadge = (
    {
        children,
    }: DiscountBadgeProps
) => (<Badge>
    {children}
</Badge>);

export default DiscountBadge;

const Badge = styled.span`
    display: inline-block;
    background: #08E085;
    border-radius: 16px;
    font-size: 11px;
    color: #fff;
    text-align: center;
    line-height: 16px;
    padding: 3px 13px;
    font-weight: 700;
    text-shadow: 1px 1px 1px rgba(0,0,0,0.2);

    & + & {
        margin-left: 8px;
    }
`;
